// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const ContentProfileLayout = require('./component-dumb')

function mapStateToProps(state) {
  const {
    embedUrl,
    likers,
    title,
    thumbnail,
    url
  } = state.articleProfile
  return {
    // Flags
    isRedditVideo: getIsRedditVideo(state),
    // Values
    embedUrl,
    likers,
    provider: getProvider(state),
    title,
    thumbnail,
    url
  }
}

function mapDispatchToProps() {

  function onLikerClick() {
    return async function () {
      await businessEvents.trackSegment('into-liker-click')
    }
  }

  return {
    onClick: onLikerClick()
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ContentProfileLayout
)

module.exports = SmartComponent

const getProvider = createSelector(
  state => state.articleProfile.meta,
  meta => {
    const provider = meta.provider.toJS()
    provider.showStreamTitle = provider.id.toLowerCase() !== provider.streamTitle.toLowerCase()
    return provider
  }
)

const getIsRedditVideo = createSelector(
  getProvider,
  state => state.articleProfile.meta,
  (provider, meta) => provider.id === 'reddit' && (meta.media.find(mediaObject => mediaObject.has('mp4_url')) !== undefined)
)
